import { css } from 'styled-components';
import {
  getTypography, getSpacing, SpacingName, TypographyName, ThemedFunctor,
} from '@doveit/lego';

export const base: ThemedFunctor = ({
  theme,
  onClick,
}) => css`
  display: flex;
  ${getSpacing.padding(theme, [SpacingName.SMALLEST, 0, SpacingName.SMALLEST, SpacingName.SMALLEST])}
  border: 1px solid ${theme.palettes.neutrals.light};
  background-color: ${theme.palettes.neutrals.lightest};
  align-items: center;

  ${onClick && `
    cursor: pointer;
    box-shadow: 0px 0px 5px rgba(0, 0, 0, 0.1);

    &:hover {
      box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.1);
    }
  `}
`;

export const picture: ThemedFunctor = ({
  theme,
}) => css`
  width: 3rem;
  height: 3rem;
  flex-shrink: 0;
  background-color: ${theme.palettes.neutrals.lighter};
  overflow: hidden;
`;

export const info: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [0, SpacingName.SMALLER])}
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

export const details: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.SMALL)}
  display: flex;
  align-items: center;
  gap: 0.375rem;

  > *:last-child {
    color: ${theme.palettes.neutrals.medium};
  }
`;
